import ServicesManagement from "../../assets/images/sidebar/service_management.svg";

const serviceManagementModule = {
  name: "Service Management",
  key: "service_management",
  imgSrc: ServicesManagement,
  submodules: [
    {
      name: "Service Dashboard & List",
      key: "service_dashboard_list",
      defaultExpanded: false,
      features: [
        {
          key: "service_dashboard_list",
          name: "Service Dashboard & List",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_service_list_and_details",
              name: "View Service List and Details",
              defaultEnabled: true,
              description: "Show service status cards and full service list"
            },
            {
              key: "manage_category_service",
              name: "Manage Category / Service",
              defaultEnabled: false,
              description: "Access category and service management section"
            }
          ]
        }
      ]
    },
    {
      name: "Category / Service Management",
      key: "category_service_management",
      defaultExpanded: false,
      features: [
        {
          key: "can_create_edit_delete_a_category_service_all_fields",
          name: "Can Create , Edit & Delete a Category & Service  ( All Fields )",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "can_create_edit_delete_new_categories_services",
              name: "Can Create , Edit & Delete New Categories & Services",
              defaultEnabled: false,
              description: "Full CRUD access to categories and services"
            }
          ]
        },
        {
          key: "can_edit_a_category_service",
          name: "Can Edit a Category & Service",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_overview_benefits_documents_deliverables",
              name: "View Overview/Benefits/Documents/Deliverables",
              defaultEnabled: true,
              description: "Display service overview, benefits, documents and deliverables"
            },
            {
              key: "update_service_status_hold_resume_update",
              name: "Update Service Status ( Hold / Resume ) - Update",
              defaultEnabled: false,
              description: "Pause or resume service"
            },
            {
              key: "update_service_banner_add_update_delete",
              name: "Update Service Banner - Add , Update , Delete",
              defaultEnabled: false,
              description: "Manage service banner image"
            },
            {
              key: "update_service_thumbnail_add_update_delete",
              name: "Update Service Thumbnail  -  Add , Update , Delete",
              defaultEnabled: false,
              description: "Manage service thumbnail image"
            },
            {
              key: "update_service_pricing_details",
              name: "Update Service Pricing Details",
              defaultEnabled: false,
              description: "Modify pricing information"
            },
            {
              key: "add_pricing_update_pricing_add_referral_update_ref",
              name: "Add Pricing  , Update Pricing , Add Referral % , Update Ref % )",
              defaultEnabled: false,
              description: "Manage pricing and referral percentages"
            },
            {
              key: "update_service_time_create_update_service_complexity_points",
              name: "Update Service Time  - Create , Update Service Complexity Points",
              defaultEnabled: false,
              description: "Adjust estimated time and complexity scoring"
            },
            {
              key: "update_renewable_reminder_update",
              name: "Update Renewable Reminder - Update",
              defaultEnabled: false,
              description: "Configure renewal reminders"
            },
            {
              key: "update_client_vault_link_update",
              name: "Update Client Vault Link - Update",
              defaultEnabled: false,
              description: "Update link to client vault"
            },
            {
              key: "view_service_status",
              name: "View Service Status",
              defaultEnabled: false,
              description: "See current service status"
            },
            {
              key: "edit_service_status",
              name: "Edit Service Status",
              defaultEnabled: false,
              description: "Manually change service status"
            }
          ]
        }
      ]
    }
  ]
};

export default serviceManagementModule;
